import React, { Fragment } from 'react';
import { CenterDot } from './CenterDot';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DotSeparatedLabels = ({
  labels = []
}) => /*#__PURE__*/_jsx(Fragment, {
  children: labels.map(value => value?.trim()).filter(value => value && value.length > 0).map((label, index, all) => /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      children: label
    }), index < all.length - 1 && /*#__PURE__*/_jsx(CenterDot, {})]
  }, index))
});